import type { IFieldInputStrategy } from '@/Core/Contracts/UI/IFieldInputStrategy'
import { toJS } from 'mobx'
import type { BaseFieldStore } from '../Stores/BaseFieldStore'
import { FieldType } from '../Stores/Types/FieldTypeEnum'

/**
 * Базова стратегія для всіх типів полів
 * Містить дефолтну логіку, яку можуть перевизначити конкретні стратегії
 */
export class BaseFieldInputStrategy implements IFieldInputStrategy {
    fieldType: FieldType = FieldType.STRING

    getValueName(field: BaseFieldStore): string {
        return field.valueName || 'value'
    }

    extractValue(event: any, field: BaseFieldStore): any {
        // Якщо це React подія з target
        if (event?.target) {
            const valueName = this.getValueName(field)
            return event.target[valueName]
        }
        // Якщо це пряме значення
        return event
    }

    transformForEdit(value: any, field: BaseFieldStore): any {
        value = toJS(value)

        // Якщо вимкнено трансформацію
        if (field.isDisableTransform) {
            return value
        }

        // Кастомний input трансформер з definition
        if (typeof field.definition.input === 'function') {
            return field.definition.input(value)
        }

        // Базова стратегія не обробляє складні об'єкти
        // Це має робити конкретна стратегія (наприклад SelectFieldStrategy)
        return value
    }

    transformForView(value: any, field: BaseFieldStore): any {
        // Якщо вимкнено трансформацію
        if (field.isDisableTransform) {
            return toJS(value)
        }

        // Кастомний view трансформер з definition
        if (typeof field.definition.view === 'function') {
            return field.definition.view(toJS(value), field.formContext)
        }

        let view = toJS(value)

        // Якщо значення порожнє
        if (!view || (Array.isArray(view) && view.length === 0)) {
            view = '-'
        }

        return view
    }

    validate(value: any, field: BaseFieldStore): string | null {
        // Базова стратегія не додає додаткової валідації
        return null
    }

    modifyInputProps(props: Record<string, any>, field: BaseFieldStore): Record<string, any> {
        // Базова стратегія не модифікує props
        return props
    }
}
